/** Task alerts become read only after the authorized task pane is displayed. */
interface Target { userId: string; taskId: string }
interface Request extends Target { resolve: () => void; reject: (error: Error) => void; timer: number }
let displayed: Target | null = null;
let pending: Request | null = null;
const matches = (left: Target, right: Target) => left.userId === right.userId && left.taskId === right.taskId;

function settle(request: Request, error?: Error): void {
  if (pending !== request) return;
  window.clearTimeout(request.timer);
  pending = null;
  if (error) request.reject(error);
  else request.resolve();
}

export function waitForTaskNotificationDisplay(userId: string, taskId: string): Promise<void> {
  if (!userId || !taskId) return Promise.reject(new Error('Task destination unavailable'));
  if (pending) settle(pending, new Error('Another task was opened'));
  if (displayed && matches(displayed, { userId, taskId })) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const request: Request = {
      userId, taskId, resolve, reject,
      timer: window.setTimeout(() => settle(request, new Error('Could not open this task')), 15000),
    };
    pending = request;
  });
}

export function reportTaskNotificationDisplay(userId: string, taskId: string): () => void {
  const target = { userId, taskId };
  displayed = target;
  if (pending && matches(pending, target)) settle(pending);
  return () => { if (displayed === target) displayed = null; };
}

export function rejectTaskNotificationDisplay(userId: string, taskId: string, error: Error): void {
  if (pending && matches(pending, { userId, taskId })) settle(pending, error);
}
